export default "__VITE_ASSET__f14d8e7b__"